import { atom } from 'jotai';
import { atomFamily, atomWithReset } from 'jotai/utils';

// Each federated realm bundles its own copy of the libs, so atoms are registered on window by key
// to make every realm resolve the same atom instance (and therefore the same state).
const map = new Map();
const getRegistry = () => {
  if (typeof window === 'undefined') return map;
  if (!window.__SHARED_JOTAI_ATOMS__) window.__SHARED_JOTAI_ATOMS__ = map;
  return window.__SHARED_JOTAI_ATOMS__;
};

export const registerSharedAtom = (key, createAtom) => {
  const registry = getRegistry();
  if (!registry.has(key)) {
    const shared = createAtom();
    shared.debugLabel = key;
    registry.set(key, shared);
  }
  return registry.get(key);
};

export const sharedAtom = (key, initialValue) => registerSharedAtom(key, () => atomWithReset(initialValue));

export const sharedAtomFamily = (key, initializeAtom, areEqual) =>
  registerSharedAtom(key, () => atomFamily(initializeAtom, areEqual));

// Read-only derived state. Prefer this over a bare jotai `atom(get => ...)` so derived state is
// shared across realms like the atoms it reads, and stays visibly distinct from writable state.
export const sharedSelector = (key, read) => registerSharedAtom(key, () => atom(read));
